import fetch from '../../utils/fetch'

// export function getWxUserInfo(openid) {
//     return fetch({
//         url: '/api/verify/getWxUserInfo?openid=' + openid,
//         method: 'GET',
//     })
// }

export function getWxUserInfo(openid) {
    return fetch({
        url: '/webApi/encrypt/verify/getWxUserInfo',
        method: 'POST',
        data:openid,
        isEncrypt:true,
        merId :"10002211252",
    })
}
